
/* injects from baggage-loader */

/*global NODE_ENV*/
'use strict';

function config($logProvider, $compileProvider, cfpLoadingBarProvider, $provide, stripeProvider) {
	'ngInject';

	$logProvider.debugEnabled(true);

	if (NODE_ENV === 'production') {
		$logProvider.debugEnabled(false);
		$compileProvider.debugInfoEnabled(false);
	}

	// Configure Stripe
	// stripeProvider.setPublishableKey('{{stripe_pk}}');

	// Loading bar config
	cfpLoadingBarProvider.includeSpinner = false;
	cfpLoadingBarProvider.includeBar = true;

	// Fix deprecated lowercase function
	angular.lowercase = angular.$$lowercase;

	$provide.decorator('taOptions', ['taRegisterTool', '$delegate', function (taRegisterTool, taOptions) {

		// Text editor toolbar config
		taOptions.toolbar = [
			['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote'],
			['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
			['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent'],
			['html', 'insertImage', 'insertLink', 'insertVideo']
		];

		return taOptions;
	}]);





}

export default config;


// WEBPACK FOOTER //
// ./src/app/index.config.js